export default "__VITE_ASSET__xMGOmeKG__"